// A handful of real-estate-domain glyphs (bed/bath/parking/size/etc.) have
// no equivalent in the shared FluentIcon set — ported as raw stroke-icon
// path data from the prototype rather than extending the generated
// dashboard-icons.json. Everything else (dismiss, edit, trash, link,
// chevrons, location, calendar, image, ...) already exists in FluentIcon;
// use <fluent-icon> for those instead of adding duplicates here.
export const REAL_ESTATE_ICON_PATHS = {
  star: 'm12 3 2.7 5.6 6.1.9-4.4 4.3 1 6.1L12 17l-5.4 2.9 1-6.1L3.2 9.5l6.1-.9L12 3Z',
  bed: 'M3 18v-6a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v6M3 18v2M21 18v2M5 10V7a1 1 0 0 1 1-1h4v4M13 10V7a1 1 0 0 1 1-1h5a1 1 0 0 1 1 1v3',
  bath: 'M4 12h16M6 12V6a2 2 0 0 1 2-2 1 1 0 0 1 1 1v1M5 12v6a3 3 0 0 0 3 3h8a3 3 0 0 0 3-3v-6',
  ruler: 'M3 16 16 3l5 5L8 21l-5-5Zm4-1 2 2m2-6 2 2m2-6 2 2',
  car: 'M5 16v-4l2-5h10l2 5v4M3 16h18M7 19v-3m10 3v-3M7.5 13h.01M16.5 13h.01',
  layers: 'm12 3 9 5-9 5-9-5 9-5Zm-9 9 9 5 9-5M3 16l9 5 9-5',
};
